import React from 'react';
import './Hero.css';

const Hero = () => {
  return (
    <section id="home" className="hero">
      <div className="hero-background">
        <div className="hero-overlay"></div>
      </div>
      
      <div className="container">
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="hero-title animate-fadeInUp">
              Bringing <span className="highlight">Stories</span> to Life
              <br />Through <span className="highlight">Art</span>
            </h1>
            <p className="hero-subtitle animate-fadeInUp">
              Professional sketch artist specializing in custom portraits, 
              illustrations, and artistic sketches. Let me capture your 
              precious moments in timeless artwork.
            </p>
            <div className="hero-buttons animate-fadeInUp">
              <button 
                className="btn"
                onClick={() => document.getElementById('portfolio').scrollIntoView({ behavior: 'smooth' })}
              >
                View My Work
              </button>
              <button 
                className="btn btn-outline"
                onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
              >
                Get Quote
              </button>
            </div>
          </div>
          
          <div className="hero-image animate-fadeInRight">
            <div className="image-placeholder">
              <img src="/profile.png" alt="Portfolio preview" className="hero-preview-image" />
              <p>Portfolio Preview</p>
            </div>
          </div>
        </div>
        
        <div className="hero-stats animate-fadeInUp">
          <div className="stat">
            <h3>500+</h3>
            <p>Artworks Created</p>
          </div>
          <div className="stat">
            <h3>200+</h3>
            <p>Happy Clients</p>
          </div>
          <div className="stat">
            <h3>5+</h3>
            <p>Years Experience</p>
          </div>
        </div>
      </div>
      
      <div className="scroll-indicator">
        <div className="scroll-arrow"></div>
      </div>
    </section>
  );
};

export default Hero;
